// @ts-check

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Layout, Page, InlineStack } from "@shopify/polaris";
import { PlusIcon, RefreshIcon } from "@shopify/polaris-icons";

import { usePostHog } from "posthog-js/react";

import { CreateUtmSetExportModal } from "components/CreateUtmSetExportModal/CreateUtmSetExportModal";
import { UtmSetExportsTable } from "components/UtmSetExportsTable/UtmSetExportsTable";

import { useGlobalContext } from "context/GlobalContext";

export default function ExportUTMSetsPage() {
  const navigate = useNavigate();
  const {
    utmSetExportsLocked,
    refetchUtmSetExports,
    isRefetchingUtmSetExports
  } = useGlobalContext();
  const posthog = usePostHog();

  const [createExportModalOpen, setCreateExportModalOpen] = useState(false);

  useEffect(() => {
    posthog.capture("$pageview");
  }, []);

  const primaryAction = (
    <InlineStack gap="100">
      <Button
        variant="secondary"
        icon={RefreshIcon}
        onClick={refetchUtmSetExports}
        loading={isRefetchingUtmSetExports}
        disabled={utmSetExportsLocked}
      >
        Refresh exports
      </Button>
      <Button
        variant="primary"
        icon={PlusIcon}
        onClick={() => setCreateExportModalOpen(true)}
        disabled={utmSetExportsLocked}
      >
        Create new export
      </Button>
    </InlineStack>
  );

  return (
    <Page
      title="Export UTM sets"
      subtitle="Export your UTM sets into CSV format"
      primaryAction={primaryAction}
      backAction={{
        content: "Back to UTM Sets",
        onAction: () => {
          navigate("/utm-sets");
        },
      }}
      fullWidth
    >
      <CreateUtmSetExportModal
        open={createExportModalOpen}
        setOpen={setCreateExportModalOpen}
      />

      <Layout>
        <Layout.Section>
          <UtmSetExportsTable />
        </Layout.Section>
      </Layout>
    </Page>
  );
};
